import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";

const ContentCardUIButtonSettings =  ({  callbackItemValue, buttonItem}) => {
  
const [buttonTitle ,setButtonTitle] =useState(buttonItem?.buttonText)
 
     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 

 return(<>


                                    <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               
           <div > 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                        
                                     <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"14px",padding:"10px"}} placeholder={`Add Button Title`} type="text"
  rows={1} name="courseTitle" value={buttonTitle} onChange={(e)=>{
    setButtonTitle(e.target.value);
  callbackItemValue(buttonItem?.id,e.target.value,"buttonText");
  }} />

                          </div>
                       
                        </div> </div>
                                 </>)

    } 
    export default ContentCardUIButtonSettings;

                     